var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-timeline" }, [
    _c(
      "div",
      { staticClass: "viq-timeline__header" },
      [
        _c("h3", { staticClass: "viq-timeline__title" }, [
          _vm._v("Regulatory Timeline"),
        ]),
        _vm._v(" "),
        !_vm.started
          ? _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.goBack } },
              [_vm._v("Back")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.started
      ? _c(
          "div",
          { staticClass: "viq-timeline__form" },
          [
            _c("p", { staticClass: "viq-timeline__desc" }, [
              _vm._v(
                "\n      Generate a chronological timeline of regulatory events for a topic or jurisdiction.\n    "
              ),
            ]),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                type: "textarea",
                rows: 3,
                placeholder:
                  "e.g., PSD2/PSD3 regulatory timeline for the EU...",
              },
              model: {
                value: _vm.topic,
                callback: function ($$v) {
                  _vm.topic = $$v
                },
                expression: "topic",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-timeline__form-row" },
              [
                _c("el-input", {
                  attrs: {
                    size: "small",
                    placeholder: "Jurisdiction (optional)",
                  },
                  model: {
                    value: _vm.jurisdiction,
                    callback: function ($$v) {
                      _vm.jurisdiction = $$v
                    },
                    expression: "jurisdiction",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !_vm.topic.trim() },
                    on: { click: _vm.generate },
                  },
                  [_vm._v("\n        Generate Timeline\n      ")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "viq-timeline__events" },
          [
            _vm._l(_vm.timelineEvents, function (event, i) {
              return _c("ViqTimelineEvent", {
                key: i,
                attrs: {
                  event: event,
                  "is-last": i === _vm.timelineEvents.length - 1,
                },
              })
            }),
            _vm._v(" "),
            _vm.isStreaming
              ? _c("div", { staticClass: "viq-timeline__loading" }, [
                  _c("span", { staticClass: "viq-timeline__spinner" }),
                  _vm._v("\n      Generating timeline...\n    "),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isStreaming && _vm.timelineEvents.length === 0
              ? _c("div", { staticClass: "viq-timeline__empty" }, [
                  _vm._v("\n      No timeline events found.\n    "),
                ])
              : _vm._e(),
          ],
          2
        ),
    _vm._v(" "),
    !_vm.isStreaming && _vm.started
      ? _c(
          "div",
          { staticClass: "viq-timeline__actions" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.exportPdf } },
              [_vm._v("Export as PDF")]
            ),
            _vm._v(" "),
            _vm.$config.features && _vm.$config.features.viqShare
              ? _c("el-button", { on: { click: _vm.share } }, [
                  _vm._v("Save & Share"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.reset } }, [
              _vm._v("New Timeline"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }